// extracted by mini-css-extract-plugin
export default {"modal":"face-capture-screen_modal__-fHLO","modalImage":"face-capture-screen_modalImage__0BXrJ"};